var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0l16 0 1 0 0 1 0 26 0 1 -1 0 -16 0 -1 0 0 -1 0 -26 0 -1 1 0zm3 13l2 0 0 2 -2 0 0 -2zm0 9l10 0 0 2 -10 0 0 -2zm0 -3l10 0 0 2 -10 0 0 -2zm0 -12l10 0 0 2 -10 0 0 -2zm0 -3l10 0 0 2 -10 0 0 -2zm12 -2l-14 0 0 24 14 0 0 -24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.72510f3748382689217a8051b6fef3ba.svg";
export { ForwardRef as ReactComponent };